import { JSONAPI_URLS } from '../../../consts/endpoints';
import fetchTableData from '../../../utils/fetchTableData';
import { isUndefined } from '../../../utils/isDefined';
import mapCustomFilters from './mapCustomFilters';

export default async function fetchSimcards({ query, client, active }) {
  const queryParams = mapQueryParams({ client, active });
  const requestUrl = JSONAPI_URLS.SIM_CARDS;

  return await fetchTableData({
    query,
    queryParams,
    requestUrl,
    defaultSort: '',
    mapCustomFilters
  });
}

export function mapQueryParams({ client, active }) {
  let queryParams = {
    include: ['owner', 'primary_card'],
    fields: { users: 'name' },
    filter: {
      client_id: { eq: client?.clientId },
      active: true
    }
  };

  if (client?.adminView === true) {
    queryParams = {
      ...queryParams,
      fields: { ...queryParams.fields, clients: 'name' },
      include: [...queryParams.include, 'client'],
      filter: { active: true, client_id: { eq: client?.clientId } }
    };

    if (isUndefined(client?.clientId)) {
      queryParams = {
        ...queryParams,
        filter: { active: true }
      };
    }
  }

  return queryParams;
}
